import React from "react";
import { Footer, Spinner } from "component-library";
import { dataTestIds } from "data-testids";
import { ReactComponent as SpotlightLogo } from "component-library/assets/svg/Spotlight-Logo-white.svg";

import { useUser } from "../../context/UserContext";
import useFetchNav from "../../hooks/useFetchNav";

interface ILayoutProps {
  children: React.ReactNode;
  removePadding?: boolean;
  hideFooter?: boolean;
}

const Layout: React.FC<React.PropsWithChildren<ILayoutProps>> = ({
  children,
  removePadding,
  hideFooter,
}) => {
  const { locale } = useUser();
  const { isLoading, data } = useFetchNav(locale);

  if (isLoading || !data) {
    return <Spinner />;
  }

  return (
    <main>
      <section
        className="flex flex-col justify-between min-h-screen"
        data-testid={dataTestIds.joiningPages["Layout.layout"]}
      >
        <header className="h-[50px] bg-color-neutral-one">
          <div className="max-w-[1140px] h-full pl-[15px] flex items-center">
            <SpotlightLogo height={30} />
          </div>
        </header>
        <main
          className={`relative flex flex-col flex-1 text-base ${
            !removePadding && "pt-4"
          }`}
        >
          {children}
        </main>
        {!hideFooter && <Footer />}
      </section>
    </main>
  );
};

export default Layout;
